.loading_spinner-wrap {
  width: 100%;
}

.loading_spinner {
  display: block;
  margin: 0 auto; /* centers the spinner wherever it is */
  fill: #333544;
}

.loading_spinner circle {
  animation-name: upAndDown;
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.05, 0.2, 0.35, 1);
  animation-iteration-count: infinite;

  &:nth-child(2) {
    animation-delay: 0.1s;
  }

  &:nth-child(3) {
    animation-delay: 0.2s;
  }
}

@keyframes upAndDown {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  25% {
    opacity: 1;
    transform: translateY(-6px);
  }
  75% {
    opacity: 1;
    transform: translateY(-6px);
  }
  100% {
    opacity: 0;
    transform: translateY(0);
  }
}
